import { useQuery } from '@tanstack/react-query';
import * as chatApi from '../../api/chat';
import { chatKeys } from './chatKeys';

export function useChatUnread() {
  return useQuery({
    queryKey: chatKeys.unread(),
    queryFn: chatApi.getUnreadSummary,
    staleTime: 60_000,
  });
}
